export default "__VITE_ASSET__3dtF9FyC__"